import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Layers, Target, RefreshCw, Zap } from 'lucide-react';
interface SlideStrategyProps {
  onContinue: () => void;
}
export function SlideStrategy({
  onContinue
}: SlideStrategyProps) {
  const [stage, setStage] = useState(0);
  const pillars = [{
    title: 'Leverage Existing Assets',
    desc: 'No new content creation required. We repurpose existing approved materials into interactive formats.',
    icon: <Layers className="w-6 h-6 text-teal-400" data-id="element-796" />
  }, {
    title: 'Rapid Deployment',
    desc: 'Centralized creation with localized distribution. Campaigns go live in days, not months.',
    icon: <Zap className="w-6 h-6 text-purple-400" data-id="element-797" />
  }, {
    title: 'Behavioral Data Capture',
    desc: 'Moving beyond vanity metrics to reveal what actually drives HCP decisions.',
    icon: <Target className="w-6 h-6 text-rose-400" data-id="element-798" />
  }, {
    title: 'Continuous Optimization',
    desc: 'Every interaction informs and improves the next campaign in a closed-loop system.',
    icon: <RefreshCw className="w-6 h-6 text-sky-400" data-id="element-799" />
  }];
  useEffect(() => {
    const timers = pillars.map((_, idx) => setTimeout(() => setStage(idx), 500 + idx * 400));
    return () => timers.forEach(clearTimeout);
  }, []);
  return <div className="h-full w-full flex flex-col px-12 py-16 md:px-24 md:py-20 max-w-7xl mx-auto" data-id="element-800">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="text-center space-y-4" data-id="element-801">
        <h2 className="text-4xl md:text-5xl font-serif text-white" data-id="element-802">
          The Operating Model
        </h2>
        <p className="text-xl text-white/60" data-id="element-803">
          Built for scale, speed, and continuous learning.
        </p>
      </motion.div>

      <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-8 items-center justify-center max-w-5xl mx-auto w-full" data-id="element-804">
        {pillars.map((pillar, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: stage >= idx ? 1 : 0,
        y: stage >= idx ? 0 : 20
      }} className="bg-navy-700/40 border border-navy-600 p-8 rounded-2xl h-full flex flex-col" data-id="element-805">
            <div className="w-12 h-12 rounded-xl bg-teal-400/10 text-teal-400 flex items-center justify-center mb-6" data-id="element-806">
              {pillar.icon}
            </div>
            <h3 className="text-xl font-semibold text-white mb-3" data-id="element-807">
              {pillar.title}
            </h3>
            <p className="text-white/60 leading-relaxed flex-1" data-id="element-808">
              {pillar.desc}
            </p>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: stage >= 5 ? 1 : 0
    }} className="mt-12 flex justify-center" data-id="element-809">
        <Button onClick={onContinue} data-id="element-810">What Snakker Does</Button>
      </motion.div>
    </div>;
}